<template>
  <vs-select
    class="w-full"
    label="Status"
    v-model="selected"
  >
    <vs-select-item
      :key="index"
      :value="item.value"
      :text="item.text"
      v-for="(item, index) in options"
    />
  </vs-select>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: [
        {
          text: 'Active',
          value: 'active',
          color: 'success'
        },
        {
          text: 'Pending',
          value: 'pending',
          color: 'warning'
        },
        {
          text: 'On Progress',
          value: 'on-progress',
          color: 'warning'
        },
        {
          text: 'Expired',
          value: 'expired',
          color: 'success'
        },
        {
          text: 'Cancelled',
          value: 'cancelled',
          color: 'success'
        }
      ]
    }
  },
  computed: {
    selected: {
      get() {
        return this.data
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  }
}
</script>
